/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Predicate from 'predicates/models/predicate';
import { computed } from '@ember/object';
export default Predicate.extend({
  isEditable: true,
  genericType: 'officeHoursSchedule',
  defaultComparison: 'in',
  name: computed('info.name', 'comparison', function () {
    return this.comparison === 'nin' ? 'Outside' : 'During';
  }),
  isValid: computed('value', 'comparison', function () {
    return ['in', 'nin'].includes(this.comparison) && !!this.value;
  })
});